import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useBundle } from '@amzn/react-arb-tools';
import exportSmallTokens from '@amzn/meridian-tokens/base/icon/export-small';
import Icon from '@amzn/meridian/icon';
import Row from '@amzn/meridian/row';
import { ReportActionSource } from '@amzn/handshake-painter-typescript-client/v1';
import { TertiaryButton } from 'src/common/buttons';
import { useOffRampToAmazon } from 'src/hooks/useOffRampToAmazon';
export const SeeMoreOnAmazonButton = ({ offRampUrl }) => {
    const [bundle, isBundleLoading] = useBundle('pages.productDetails');
    const offRampToAmazon = useOffRampToAmazon();
    if (isBundleLoading)
        return null;
    const onSeeMoreButtonClick = () => {
        offRampToAmazon(offRampUrl, ReportActionSource.BuyBox);
    };
    return (_jsx(TertiaryButton, { onClick: onSeeMoreButtonClick, shape: "small", "data-testid": "see-more-on-amazon-button", children: _jsxs(Row, { spacing: "300", children: [_jsx("span", { children: bundle.getMessage('seeMoreOnAmazon') }), _jsx(Icon, { tokens: exportSmallTokens })] }) }));
};
